import { useContext } from "react";
import { HookOutOfContextError } from "@jugl-web/utils";
import { SubscriptionV2Context } from "./SubscriptionV2Context";

export const useSubscriptionV2 = () => {
  const context = useContext(SubscriptionV2Context);

  if (!context) {
    throw new HookOutOfContextError(
      "useSubscriptionV2",
      "SubscriptionV2Context"
    );
  }

  return context;
};
